import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LayoutModule, SharedModule } from '@app/shared';
import {
    PurchaseOrderBarcodeModalComponent, PurchaseOrderEditComponent, PurchaseOrderListComponent, PurchaseOrderTechinicianViewComponent, PurchaseOrderTechnicianDeletePopupComponent, PurchaseOrderTechnicianEditComponent, PurchaseOrderViewComponent, StockCodeInfoPopupComponent
} from '@inventory/components/purchase-order';
import { RouterModule, Routes } from '@angular/router';
import { NgxPrintModule } from 'ngx-print';
import { BarcodePrinterModule } from '../barcode-printer/barcode-printer/barcode-printer.module';
import { PurchaseOrderCreateModelComponent } from './purchase-order-create-model.component';
import { NgxBarcode6Module } from 'ngx-barcode6';
import { AuthenticationGuard as AuthGuard } from '@app/shared/services/authguards';
import { MatAutocompleteModule, MatCheckboxModule, MatDialogModule, MatExpansionModule, MatInputModule, MatProgressSpinnerModule, MatTabsModule } from '@angular/material';

const routes: Routes = [
    { path: '', component: PurchaseOrderListComponent, data: { title: 'Purchase Order List' }, canActivate: [AuthGuard] },
    { path: 'view', component: PurchaseOrderViewComponent, data: { title: 'View Purchase Order' }, canActivate: [AuthGuard] },
    { path: 'add-edit', component: PurchaseOrderEditComponent, data: { title: 'Create Technician Job' }, canActivate: [AuthGuard] },
    { path: 'technician-view', component: PurchaseOrderTechinicianViewComponent, data: { title: 'View Technician Job' }, canActivate: [AuthGuard] },
    { path: 'technician-edit', component: PurchaseOrderTechnicianEditComponent, data: { title: 'Update Technician Job' }, canActivate: [AuthGuard] }
];

@NgModule({
    declarations: [
        PurchaseOrderListComponent,
        PurchaseOrderViewComponent,
        PurchaseOrderEditComponent,
        PurchaseOrderTechinicianViewComponent,
        PurchaseOrderTechnicianEditComponent,
        PurchaseOrderCreateModelComponent,
        StockCodeInfoPopupComponent,
        PurchaseOrderBarcodeModalComponent,
        PurchaseOrderTechnicianDeletePopupComponent
    ],
    imports: [
        CommonModule,
        LayoutModule,
        MatExpansionModule,
        MatProgressSpinnerModule,
        MatInputModule,
        MatCheckboxModule,
        MatTabsModule,
        MatDialogModule,
        MatAutocompleteModule,
        BarcodePrinterModule,
        SharedModule,
        NgxBarcode6Module,
        NgxPrintModule,
        RouterModule.forChild(routes)
    ],
    entryComponents: [StockCodeInfoPopupComponent, PurchaseOrderBarcodeModalComponent, PurchaseOrderTechnicianDeletePopupComponent, PurchaseOrderCreateModelComponent]

})

export class PurchaseOrderModule { }
